<template>
  <div
    class="bg-oyster-pink-200 text-center md:flex md:space-x-2 md:justify-center md:items-center md:space-y-0 gap-4 text-cerise-red-600 space-y-4 py-4 mt-4"
  >
    <h1 class="font-extrabold text-xl leading-5">Hai già una card?</h1>
    <nuxt-link to="/login">
      <CorePrimaryButton class="mt-3 lg:mt-0"> ACCEDI </CorePrimaryButton>
    </nuxt-link>
  </div>
</template>
